import client from './client';

export default (function NoteService() {
  let service;

  if (!service) {
    service = client.service('notes');
  }

  return service;
}());
